import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { StoreUtils } from '@/shared/util/store-utils'

export const billingGridCasesMasterColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('accounting.field.caseNumber'),
            colId: 'casCasenumber',
            field: 'caseNumber',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.status'),
            field: 'status',
            type: AgGridColumnType.COMMON_CASE_STATUS,
            cellRendererParams: {
                labelField: 'translatedName'
            },
            exportField: 'status.translatedName',
            exportType: AgGridExportType.TEXT
        },
        {
            headerName: i18n.tc('accounting.field.pathologist'),
            colId: 'pathologist.normalizedFullName',
            field: 'pathologist.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.requestingCenter'),
            field: 'physicianDepartment.center.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.requestingProfessional'),
            colId: 'physicianPetitioner.normalizedFullName',
            field: 'physicianPetitioner.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.insurance'),
            field: 'insurer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.insuranceDocument'),
            field: 'referralNumber',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.insurancePolicy'),
            field: 'insuranceNumber',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.receptionDate'),
            colId: 'casRequestDate',
            field: 'receptionDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.validationDate'),
            colId: 'casValidationDate',
            field: 'validationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.automationError'),
            colId: 'hasAutomaticBillableConflicts',
            field: 'errorAutomaticAssignment',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            headerName: i18n.tc('global.regime'),
            field: 'regime.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            filter: false,
            sortable: false,
            suppressSizeToFit: true
        },
        {
            headerValueGetter: () => StoreUtils.globalParameters?.mainPatientIdentifierType.name,
            colId: 'patient.mainPatientIdentifier',
            field: 'patient.mainPatientIdentifier.paiIdentifier',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerValueGetter: () => StoreUtils.globalParameters?.secondaryPatientIdentifierType.name,
            colId: 'patient.secondaryPatientIdentifier',
            field: 'patient.secondaryPatientIdentifier.paiIdentifier',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('grid.patName'),
            colId: 'patient.patName',
            field: 'patient.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('grid.patSurname1'),
            colId: 'patient.patSurname1',
            field: 'patient.surname1',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('grid.patSurname2'),
            colId: 'patient.patSurname2',
            field: 'patient.surname2',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        }
    ]
